import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MenuCommonComponent } from '@app/shared/menu-common/menu-common.component';

@Component({
    selector: 'app-home',
    imports: [MenuCommonComponent],
    templateUrl: './home.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './home.component.scss'
})
export class HomeComponent {

}
